<template>
  <div class="page-container">
    <div class="panel-card search-card">
      <el-form :model="searchForm" label-position="top" class="search-form">
        <div class="search-fields">
          <el-form-item label="产品分类" class="field-item field-category">
            <el-select
              v-model="searchForm.type"
              placeholder="全部"
              clearable
              class="field-control"
              @change="handleCategorySelectChange"
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.type"
                :label="item.bigCategoryName"
                :value="item.type"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品CODE" class="field-item field-code">
            <el-input v-model="searchForm.productCode" placeholder="请输入产品CODE" clearable class="field-control" />
          </el-form-item>
          <el-form-item label="产品名称" class="field-item field-name">
            <el-input v-model="searchForm.productName" placeholder="请输入产品名称" clearable class="field-control" />
          </el-form-item>
          <el-form-item label="是否热门" class="field-item field-flag">
            <el-select v-model="searchForm.isHot" placeholder="全部" clearable class="field-control">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否自选" class="field-item field-flag">
            <el-select v-model="searchForm.isFavoriteDefault" placeholder="全部" clearable class="field-control">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否显示" class="field-item field-flag">
            <el-select v-model="searchForm.isDisplay" placeholder="全部" clearable class="field-control">
              <el-option label="显示" :value="1" />
              <el-option label="隐藏" :value="2" />
            </el-select>
          </el-form-item>
        </div>
        <div class="search-actions">
          <el-button type="primary" icon="el-icon-search" class="search-btn" @click="handleSearch">搜索</el-button>
          <el-button class="reset-btn" @click="resetSearch">重置</el-button>
        </div>
      </el-form>
    </div>

    <div class="panel-card category-bar">
      <span
        class="category-item category-item-all"
        :class="{ 'is-active': searchForm.type === null }"
        @click="quickFilterCategory(null)"
      >
        <span class="dot dot-all"></span>全部分类
      </span>
      <span
        v-for="item in categoryOptions"
        :key="item.type"
        class="category-item"
        :class="{ 'is-active': searchForm.type === item.type }"
        @click="quickFilterCategory(item.type)"
      >
        <span class="dot" :style="{ backgroundColor: categoryColor(item.bigCategoryName) }"></span>{{ item.bigCategoryName }}
      </span>
    </div>

    <div class="panel-card table-card">
      <div class="table-header">
        <div class="table-title">产品列表（共 {{ total }} 个）</div>
        <div class="header-actions">
          <el-button v-auth="'business:tradeProduct:edit'" type="warning" size="small" icon="el-icon-star-off" @click="batchSet('isFavoriteDefault', 1)">批量设为自选</el-button>
          <el-button v-auth="'business:tradeProduct:edit'" type="primary" size="small" icon="el-icon-magic-stick" @click="batchSet('isHot', 1)">批量设为热门</el-button>
          <el-button v-auth="'business:tradeProduct:sync'" size="small" icon="el-icon-refresh" @click="handleSyncAll">拉取MT5基线</el-button>
          <el-button v-auth="'business:tradeProduct:log'" size="small" icon="el-icon-document" @click="openAllLogs">业务日志</el-button>
        </div>
      </div>

      <el-table
        ref="productTable"
        :data="tableData"
        border
        v-loading="loading"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="46" align="center" />
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="产品分类" min-width="120">
          <template slot-scope="scope">
            <span class="category-cell">
              <span class="dot" :style="{ backgroundColor: categoryColorByRow(scope.row) }"></span>
              {{ scope.row.bigCategoryName || typeName(scope.row.type) || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="productCode" label="产品CODE" min-width="120" />
        <el-table-column prop="productName" label="产品名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="currencyBase" label="基础货币" width="90" align="center" />
        <el-table-column prop="currencyProfit" label="盈亏货币" width="90" align="center" />
        <el-table-column prop="digits" label="小数位" width="80" align="center" />
        <el-table-column label="设为热门" width="90" align="center">
          <template slot-scope="scope">
            <el-checkbox v-auth="'business:tradeProduct:edit'" :value="scope.row.isHot === 1" @change="toggleBizFlag(scope.row, 'isHot', $event)" />
          </template>
        </el-table-column>
        <el-table-column label="设为自选" width="90" align="center">
          <template slot-scope="scope">
            <el-checkbox v-auth="'business:tradeProduct:edit'" :value="scope.row.isFavoriteDefault === 1" @change="toggleBizFlag(scope.row, 'isFavoriteDefault', $event)" />
          </template>
        </el-table-column>
        <el-table-column label="是否显示" width="90" align="center">
          <template slot-scope="scope">
            <el-checkbox v-auth="'business:tradeProduct:edit'" :value="scope.row.isDisplay === 1" @change="toggleBizFlag(scope.row, 'isDisplay', $event)" />
          </template>
        </el-table-column>
        <el-table-column label="匹配状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="matchStatusType(scope.row.matchStatus)" size="mini">
              {{ matchStatusText(scope.row.matchStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="lastSyncResult" label="最近结果" min-width="150" show-overflow-tooltip />
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-auth="'business:tradeProduct:edit'" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-auth="'business:tradeProduct:log'" type="text" size="small" @click="openLog(scope.row)">日志</el-button>
            <el-button v-auth="'business:tradeProduct:sync'" type="text" size="small" @click="handleSyncOne(scope.row)">拉取</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="(v) => { pageSize = v; fetchList() }"
        @current-change="(v) => { pageNum = v; fetchList() }"
        :current-page="pageNum"
        :page-sizes="[10, 15, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="760px"
      :close-on-click-modal="false"
      class="product-edit-dialog"
    >
      <el-tabs v-model="activeEditTab" class="edit-tabs">
        <el-tab-pane label="常规" name="general">
          <el-form :model="form" label-position="top" size="small" class="tab-form">
            <div class="readonly-note">MT5 同步字段仅展示，业务配置字段可编辑保存</div>
            <el-form-item label="交易品种">
              <el-input v-model="form.productCode" disabled />
            </el-form-item>
            <el-form-item label="产品名称">
              <el-input v-model="form.productName" disabled />
            </el-form-item>
            <el-form-item label="产品分类">
              <el-select v-model="form.bigCategoryId" disabled style="width: 100%;">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.bigCategoryId"
                  :label="item.bigCategoryName"
                  :value="item.bigCategoryId"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="小数位数">
              <el-input v-model="form.digits" disabled />
            </el-form-item>
            <el-form-item label="点差">
              <el-input v-model="form.spread" disabled />
            </el-form-item>
            <el-form-item label="排序">
              <el-input-number v-model="form.sort" :min="0" controls-position="right" style="width: 100%;" />
            </el-form-item>

            <div class="tab-section-title">业务配置</div>
            <div class="biz-card">
              <el-form-item label="产品别名">
                <el-input v-model="form.productAlias" placeholder="用于业务展示的别名" />
              </el-form-item>
              <el-form-item label="产品描述">
                <el-input v-model="form.productDesc" type="textarea" :rows="3" placeholder="业务侧补充描述" />
              </el-form-item>
              <div class="business-switch-row">
                <el-form-item label="设为热门">
                  <el-switch v-model="form.isHot" :active-value="1" :inactive-value="2" />
                </el-form-item>
                <el-form-item label="设为自选">
                  <el-switch v-model="form.isFavoriteDefault" :active-value="1" :inactive-value="2" />
                </el-form-item>
                <el-form-item label="是否显示">
                  <el-switch v-model="form.isDisplay" :active-value="1" :inactive-value="2" />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="货币" name="currency">
          <el-form :model="form" label-position="top" size="small" class="tab-form">
            <el-form-item label="基础货币">
              <el-input v-model="form.currencyBase" disabled />
            </el-form-item>
            <el-form-item label="盈亏货币">
              <el-input v-model="form.currencyProfit" disabled />
            </el-form-item>
            <el-form-item label="保证金币种">
              <el-input v-model="form.currencyMargin" disabled />
            </el-form-item>
            <el-form-item label="点差平衡">
              <div class="slider-label">{{ spreadBalanceLabel() }}</div>
              <el-slider :value="50" disabled :show-tooltip="false" />
            </el-form-item>
            <el-form-item label="合约大小">
              <el-input v-model="form.contractSize" disabled />
            </el-form-item>
            <el-form-item label="PIP">
              <el-input v-model="form.pointValue" disabled />
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="报价" name="quote">
          <el-form :model="form" label-position="top" size="small" class="tab-form">
            <el-form-item label="报价模式">
              <el-select :value="quoteModeLabel(form.quoteMode)" disabled style="width: 100%;">
                <el-option :label="quoteModeLabel(form.quoteMode)" :value="quoteModeLabel(form.quoteMode)" />
              </el-select>
            </el-form-item>
            <el-form-item label="报价精度">
              <el-input :value="form.digits" disabled />
            </el-form-item>
            <el-form-item label="最小变动价位">
              <el-input :value="form.pointValue" disabled />
            </el-form-item>
            <el-form-item label="报价超时(秒)">
              <el-input :value="form.quoteTimeoutSec" disabled />
            </el-form-item>
            <el-form-item label="允许重新报价" class="checkbox-form-item">
              <el-checkbox :value="form.allowRequote === 1" disabled>允许重新报价</el-checkbox>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="交易时间" name="session">
          <div v-loading="sessionLoading" class="tab-form">
            <el-form :model="form" label-position="top" size="small">
              <el-form-item label="非交易时段提示">
                <el-input v-model="form.offlineNotice" placeholder="市场休市，暂无法交易" />
              </el-form-item>
            </el-form>

            <div class="tab-section-title">每周交易时段配置</div>
            <el-table :data="sessionRows" border size="small" class="session-table">
              <el-table-column prop="weekLabel" label="星期" width="90" align="center" />
              <el-table-column label="行情" min-width="220">
                <template slot-scope="scope">
                  <el-input :value="scope.row.marketText" disabled />
                </template>
              </el-table-column>
              <el-table-column label="交易" min-width="220">
                <template slot-scope="scope">
                  <el-input :value="scope.row.tradeText" disabled />
                </template>
              </el-table-column>
            </el-table>
            <div class="session-tip">支持多个时段，格式如：`00:00-21:00 21:15-00:00`</div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button v-auth="'business:tradeProduct:edit'" size="small" type="primary" @click="save">确认保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="logDialogTitle"
      :visible.sync="logDialogVisible"
      width="920px"
      :close-on-click-modal="false"
    >
      <div class="log-filter-bar">
        <span class="log-product-title">{{ currentLogProduct.id ? `${currentLogProduct.productCode || '-'} / ${currentLogProduct.productName || '-'}` : '全部产品业务日志' }}</span>
        <el-input
          v-if="!currentLogProduct.id"
          v-model="logFilter.productCode"
          placeholder="产品CODE"
          clearable
          size="small"
          style="width: 140px;"
        />
        <el-select v-model="logFilter.actionType" placeholder="全部操作类型" clearable size="small" style="width: 150px;">
          <el-option label="创建业务配置" :value="1" />
          <el-option label="编辑业务配置" :value="2" />
          <el-option label="启用产品" :value="3" />
          <el-option label="禁用产品" :value="4" />
        </el-select>
        <el-input v-model="logFilter.operator" placeholder="操作人" clearable size="small" style="width: 140px;" />
        <el-date-picker v-model="logFilter.startDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" size="small" style="width: 140px;" />
        <el-date-picker v-model="logFilter.endDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 140px;" />
        <el-button size="small" @click="resetLogFilter">重置</el-button>
        <el-button type="primary" size="small" @click="fetchLogs">搜索</el-button>
      </div>

      <el-table :data="logTableData" border v-loading="logLoading" size="small" style="width: 100%;">
        <el-table-column prop="operateTime" label="操作时间" width="170" />
        <el-table-column v-if="!currentLogProduct.id" prop="productCode" label="产品CODE" width="120" />
        <el-table-column v-if="!currentLogProduct.id" prop="productName" label="产品名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="操作类型" width="120" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="actionTypeTag(scope.row.actionType)">
              {{ actionTypeText(scope.row.actionType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" width="120" />
        <el-table-column prop="actionDetail" label="变更内容" min-width="360" show-overflow-tooltip />
      </el-table>

      <el-pagination
        @size-change="(v) => { logPageSize = v; fetchLogs() }"
        @current-change="(v) => { logPageNum = v; fetchLogs() }"
        :current-page="logPageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="logPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="logTotal"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  exchangeProductAddOrUpdate,
  exchangeProductDetail,
  exchangeProductList,
  exchangeProductLogList,
  exchangeProductSessionList,
  exchangeProductStatus,
  exchangeProductSyncAll,
  exchangeProductSyncOne
} from '@/api/tradeProduct'

export default {
  name: 'ExchangeProductList',
  data() {
    return {
      loading: false,
      tableData: [],
      selectedRows: [],
      total: 0,
      pageNum: 1,
      pageSize: 15,
      searchForm: {
        bigCategoryId: null,
        type: null,
        productCode: '',
        productName: '',
        isHot: null,
        isFavoriteDefault: null,
        isDisplay: null,
        matchStatus: null,
        label: ''
      },
      categoryOptions: this.createCategoryOptions(),
      dialogVisible: false,
      dialogTitle: '交易品种',
      activeEditTab: 'general',
      form: this.createEmptyForm(),
      sessionLoading: false,
      sessionRows: this.createEmptySessionRows(),
      logDialogVisible: false,
      logLoading: false,
      logTableData: [],
      logTotal: 0,
      logPageNum: 1,
      logPageSize: 10,
      currentLogProduct: {
        id: null,
        productCode: '',
        productName: ''
      },
      logDialogTitle: '业务变更日志',
      logFilter: this.createEmptyLogFilter()
    }
  },
  mounted() {
    this.searchForm.label = this.$route.query.label || ''
    this.fetchList()
  },
  methods: {
    createCategoryOptions() {
      return [
        { type: 1, bigCategoryName: '贵金属' },
        { type: 4, bigCategoryName: '能源' },
        { type: 5, bigCategoryName: '农产品' },
        { type: 2, bigCategoryName: '外汇' },
        { type: 3, bigCategoryName: '股指' },
        { type: 6, bigCategoryName: '港股' },
        { type: 7, bigCategoryName: '美股' },
        { type: 8, bigCategoryName: '数字货币' }
      ]
    },
    createEmptyForm() {
      return {
        id: null,
        bigCategoryName: '',
        productCode: '',
        path: '',
        productName: '',
        type: null,
        bigCategoryId: null,
        bigCategoryId: null,
        productAlias: '',
        productDesc: '',
        sort: 0,
        isHot: 2,
        isDisplay: 1,
        isFavoriteDefault: 2,
        offlineNotice: '',
        digits: '',
        spread: '',
        currencyBase: '',
        currencyProfit: '',
        currencyMargin: '',
        contractSize: '',
        pointValue: '',
        quoteMode: null,
        quoteTimeoutSec: '',
        allowRequote: 2
      }
    },
    createEmptySessionRows() {
      return [
        { weekDay: 0, weekLabel: '星期天', marketText: '-', tradeText: '-' },
        { weekDay: 1, weekLabel: '星期一', marketText: '-', tradeText: '-' },
        { weekDay: 2, weekLabel: '星期二', marketText: '-', tradeText: '-' },
        { weekDay: 3, weekLabel: '星期三', marketText: '-', tradeText: '-' },
        { weekDay: 4, weekLabel: '星期四', marketText: '-', tradeText: '-' },
        { weekDay: 5, weekLabel: '星期五', marketText: '-', tradeText: '-' },
        { weekDay: 6, weekLabel: '星期六', marketText: '-', tradeText: '-' }
      ]
    },
    createEmptyLogFilter() {
      return {
        productCode: '',
        actionType: null,
        operator: '',
        startDate: '',
        endDate: ''
      }
    },
    fetchList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchForm,
        type: this.normalizeCategoryId(this.searchForm.type)
      }
      this.loading = true
      exchangeProductList(params).then(res => {
        if (res.code === 0) {
          this.tableData = (res.result && res.result.list) || []
          this.total = (res.result && res.result.total) || 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pageNum = 1
      this.fetchList()
    },
    handleCategorySelectChange(value) {
      this.searchForm.type = this.normalizeCategoryId(value)
      this.pageNum = 1
      this.fetchList()
    },
    normalizeCategoryId(value) {
      if (value === null || value === undefined || value === '') {
        return null
      }
      const num = Number(value)
      return Number.isNaN(num) ? null : num
    },
    resetSearch() {
      this.searchForm = {
        bigCategoryId: null,
        type: null,
        productCode: '',
        productName: '',
        isHot: null,
        isFavoriteDefault: null,
        isDisplay: null,
        matchStatus: null,
        label: this.$route.query.label || ''
      }
      this.pageNum = 1
      this.fetchList()
    },
    quickFilterCategory(type) {
      this.searchForm.type = this.normalizeCategoryId(type)
      this.pageNum = 1
      this.fetchList()
    },
    handleSyncAll() {
      this.$confirm('确定重新从 MT5 拉取产品基线吗？', '提示', { type: 'warning' }).then(() => {
        exchangeProductSyncAll({}).then(res => {
          if (res.code === 0) {
            this.$message.success(res.result || '拉取成功')
            this.fetchList()
          }
        })
      }).catch(() => {})
    },
    handleSyncOne(row) {
      exchangeProductSyncOne(row.productCode).then(res => {
        if (res.code === 0) {
          this.$message.success(res.result || '拉取成功')
          this.fetchList()
        }
      })
    },
    toggleStatus(row) {
      exchangeProductStatus(row.id, row.isEnabled === 1 ? 2 : 1).then(res => {
        if (res.code === 0) {
          this.$message.success('状态更新成功')
          this.fetchList()
          this.refreshLogsIfNeeded(row.id)
        }
      })
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || []
    },
    toggleBizFlag(row, field, checked) {
      const payload = {
        id: row.id,
        productCode: row.productCode
      }
      payload[field] = checked ? 1 : 2
      exchangeProductAddOrUpdate(payload).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.fetchList()
          this.refreshLogsIfNeeded(row.id)
        }
      })
    },
    batchSet(field, value) {
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择产品')
        return
      }
      const tasks = this.selectedRows.map(row => exchangeProductAddOrUpdate({
        id: row.id,
        productCode: row.productCode,
        [field]: value
      }))
      Promise.all(tasks).then(() => {
        this.$message.success('批量设置成功')
        this.fetchList()
      })
    },
    openEdit(row) {
      this.sessionLoading = true
      Promise.all([
        exchangeProductDetail(row.id),
        exchangeProductSessionList(row.id)
      ]).then(([detailRes, sessionRes]) => {
        if (detailRes.code !== 0) return
        this.form = Object.assign(this.createEmptyForm(), detailRes.result || {})
        this.sessionRows = this.buildSessionRows((sessionRes.result || []))
        this.activeEditTab = 'general'
        this.dialogTitle = `交易品种: ${this.form.productCode || ''}`
        this.dialogVisible = true
      }).finally(() => {
        this.sessionLoading = false
      })
    },
    openLog(row) {
      this.currentLogProduct = {
        id: row.id,
        productCode: row.productCode,
        productName: row.productName
      }
      this.logDialogTitle = `业务变更日志：${row.productCode || '-'}`
      this.logFilter = this.createEmptyLogFilter()
      this.openLogDialog()
    },
    openAllLogs() {
      this.currentLogProduct = {
        id: null,
        productCode: '',
        productName: ''
      }
      this.logDialogTitle = '业务变更日志'
      this.logFilter = this.createEmptyLogFilter()
      this.openLogDialog()
    },
    openLogDialog() {
      this.logPageNum = 1
      this.logPageSize = 10
      this.logTableData = []
      this.logTotal = 0
      this.logDialogVisible = true
      this.fetchLogs()
    },
    fetchLogs() {
      this.logLoading = true
      const params = {
        pageNum: this.logPageNum,
        pageSize: this.logPageSize,
        ...this.logFilter
      }
      if (this.currentLogProduct.id) {
        params.productId = this.currentLogProduct.id
        params.productCode = this.currentLogProduct.productCode
      }
      exchangeProductLogList({
        ...params
      }).then(res => {
        if (res.code === 0) {
          this.logTableData = (res.result && res.result.list) || []
          this.logTotal = (res.result && res.result.total) || 0
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    resetLogFilter() {
      this.logFilter = this.createEmptyLogFilter()
      this.logPageNum = 1
      this.fetchLogs()
    },
    save() {
      if (!this.form.id) {
        this.$message.warning('当前仅支持编辑已同步到本地的产品')
        return
      }
      const payload = {
        id: this.form.id,
        productCode: this.form.productCode,
        path: this.form.path,
        productAlias: this.form.productAlias,
        productDesc: this.form.productDesc,
        sort: this.form.sort,
        isHot: this.form.isHot,
        isDisplay: this.form.isDisplay,
        isFavoriteDefault: this.form.isFavoriteDefault,
        offlineNotice: this.form.offlineNotice
      }
      exchangeProductAddOrUpdate(payload).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchList()
          this.refreshLogsIfNeeded(this.form.id)
        }
      })
    },
    buildSessionRows(sessionList) {
      const rows = this.createEmptySessionRows()
      const rowMap = {}
      rows.forEach(item => {
        rowMap[item.weekDay] = item
      })
      ;(sessionList || []).forEach(item => {
        const row = rowMap[item.weekDay]
        if (!row) return
        const timeText = this.buildSessionText(item)
        if (item.sessionType === 0) {
          row.marketText = row.marketText === '-' ? timeText : `${row.marketText} ${timeText}`
        } else if (item.sessionType === 1) {
          row.tradeText = row.tradeText === '-' ? timeText : `${row.tradeText} ${timeText}`
        }
      })
      return rows
    },
    buildSessionText(item) {
      const open = item.openTimeText || this.minuteText(item.openMinute)
      const close = item.closeTimeText || this.minuteText(item.closeMinute)
      return `${open}-${close}`
    },
    minuteText(value) {
      if (value === null || value === undefined || value === '') {
        return '--:--'
      }
      const intValue = Number(value)
      const hour = String(Math.floor(intValue / 60)).padStart(2, '0')
      const minute = String(intValue % 60).padStart(2, '0')
      return `${hour}:${minute}`
    },
    quoteModeLabel(value) {
      const map = {
        0: '买价图表',
        1: '最新价图表',
        2: '流式报价'
      }
      return map[value] || '流式报价'
    },
    spreadBalanceLabel() {
      const spread = Number(this.form.spread || 0)
      return spread ? `-${spread}bid / -${spread}ask` : '-'
    },
    refreshLogsIfNeeded(productId) {
      if (!this.logDialogVisible) {
        return
      }
      if (!this.currentLogProduct.id || this.currentLogProduct.id === productId) {
        this.logPageNum = 1
        this.fetchLogs()
      }
    },
    matchStatusText(status) {
      const map = { 1: '未匹配', 2: '已匹配', 3: 'MT5不存在' }
      return map[status] || '-'
    },
    matchStatusType(status) {
      const map = { 1: 'info', 2: 'success', 3: 'danger' }
      return map[status] || 'info'
    },
    categoryColor(name) {
      const map = {
        贵金属: '#f5b041',
        能源: '#16a085',
        农产品: '#7cb342',
        外汇: '#4a90e2',
        股指: '#8e6ff7',
        港股: '#e85aad',
        美股: '#4db6d6',
        数字货币: '#f39c5a'
      }
      return map[name] || '#c0c4cc'
    },
    typeName(type) {
      const item = this.categoryOptions.find(option => option.type === type)
      return item ? item.bigCategoryName : ''
    },
    categoryColorByRow(row) {
      return this.categoryColor(row.bigCategoryName || this.typeName(row.type))
    },
    actionTypeText(type) {
      const map = {
        1: '创建业务配置',
        2: '编辑业务配置',
        3: '启用产品',
        4: '禁用产品'
      }
      return map[type] || '-'
    },
    actionTypeTag(type) {
      const map = {
        1: 'primary',
        2: 'warning',
        3: 'success',
        4: 'info'
      }
      return map[type] || 'info'
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.panel-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(31, 35, 41, 0.04);
  padding: 16px;
  margin-bottom: 12px;
}

.search-card {
  padding: 20px 22px 18px;
}

.search-form {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px 18px;
}

.search-fields {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0 16px;
}

.field-item {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 0;
  margin-bottom: 14px;
}

::v-deep .search-card .search-form.el-form--label-top .el-form-item__label {
  padding-right: 0;
  padding-bottom: 6px !important;
  height: auto !important;
  line-height: 18px !important;
  color: #303133;
  font-size: 13px;
  font-weight: 500;
  white-space: normal;
  float: none;
  display: inline-block;
}

::v-deep .search-card .search-form.el-form--label-top .el-form-item__content {
  line-height: 38px !important;
}

.field-control {
  width: 140px;
}

.field-category .field-control,
.field-flag .field-control {
  width: 120px;
}

.field-code .field-control,
.field-name .field-control {
  width: 164px;
}

.search-form :deep(.el-input__inner) {
  height: 38px;
  line-height: 38px;
  border-radius: 6px;
  border-color: #dcdfe6;
  font-size: 13px;
  padding: 0 12px;
}

.search-form :deep(.el-select .el-input__inner) {
  height: 38px;
  line-height: 38px;
  padding-right: 30px;
}

.search-form :deep(.el-input__icon) {
  line-height: 38px;
}

.search-form :deep(.el-input__inner:hover) {
  border-color: #c0c4cc;
}

.search-form :deep(.el-input__inner:focus),
.search-form :deep(.el-select .el-input.is-focus .el-input__inner) {
  border-color: var(--brand-primary);
}

.search-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 10px;
  min-height: 62px;
  padding-bottom: 14px;
}

.search-btn,
.reset-btn {
  min-width: 84px;
  height: 38px;
  padding: 0 20px;
  border-radius: 6px;
  font-size: 13px;
}

.search-btn {
  background: var(--brand-primary);
  border-color: var(--brand-primary);
}

.reset-btn {
  border-color: #dcdfe6;
  color: #606266;
  background: #fff;
}

.category-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  color: #606266;
  padding: 14px 18px;
}

.category-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.category-item:hover {
  background: #f5f7fa;
  border-color: #e4e7ed;
  box-shadow: 0 2px 8px rgba(31, 35, 41, 0.06);
}

.category-item-all {
  font-weight: 600;
  color: #303133;
}

.category-item.is-active {
  background: #f5f7fa;
  border-color: #e4e7ed;
  box-shadow: 0 2px 8px rgba(31, 35, 41, 0.08);
  color: #303133;
  font-weight: 600;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.dot-all {
  background: #303133;
}

.table-card {
  padding: 18px 18px 8px;
}

.table-header {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.header-actions {
  display: flex;
  gap: 8px;
}

@media (max-width: 1440px) {
  .search-form {
    flex-direction: column;
  }

  .search-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

.edit-tabs {
  margin-top: -8px;
}

.tab-form {
  padding: 4px 4px 0;
}

.readonly-note {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f6fbfb;
  color: #6b7280;
  font-size: 12px;
}

.tab-section-title {
  margin: 8px 0 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
}

.biz-card {
  padding: 14px 14px 2px;
  border-radius: 10px;
  background: #fafbfc;
  border: 1px solid #edf0f3;
}

.business-switch-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.business-switch-row .el-form-item {
  min-width: 120px;
}

.slider-label {
  margin-bottom: 6px;
  color: #00a38a;
  font-size: 13px;
}

.checkbox-form-item {
  margin-bottom: 0;
}

.session-table {
  margin-bottom: 8px;
}

.log-filter-bar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px;
  background: #fafafa;
  border-radius: 4px;
}

.category-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.log-product-title {
  min-width: 220px;
  color: #606266;
  font-weight: 500;
}

.session-tip {
  margin-bottom: 12px;
  color: #909399;
  font-size: 12px;
}

.preview-head {
  margin-bottom: 12px;
  color: #606266;
}

::v-deep .product-edit-dialog .el-dialog {
  border-radius: 12px;
}

::v-deep .product-edit-dialog .el-dialog__header {
  padding: 20px 24px 14px;
  border-bottom: 1px solid #ebeef5;
}

::v-deep .product-edit-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

::v-deep .product-edit-dialog .el-dialog__body {
  padding: 0 0 12px;
  max-height: 72vh;
  overflow-y: auto;
  background: #fff;
}

::v-deep .product-edit-dialog .el-dialog__footer {
  padding: 14px 24px 18px;
  border-top: 1px solid #ebeef5;
}

::v-deep .edit-tabs .el-tabs__header {
  margin: 0;
  padding: 0 16px;
}

::v-deep .edit-tabs .el-tabs__nav-wrap::after {
  background-color: #ebeef5;
}

::v-deep .edit-tabs .el-tabs__item {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #909399;
}

::v-deep .edit-tabs .el-tabs__item.is-active {
  color: #0aa28a;
  font-weight: 600;
}

::v-deep .edit-tabs .el-tabs__active-bar {
  background-color: #0aa28a;
}

::v-deep .edit-tabs .el-tabs__content {
  padding: 16px 24px 0;
}

::v-deep .product-edit-dialog .el-form-item__label {
  padding-bottom: 6px;
  color: #606266;
  font-size: 13px;
  line-height: 1.2;
}

::v-deep .product-edit-dialog .el-input.is-disabled .el-input__inner,
::v-deep .product-edit-dialog .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
  background: #f5f7fa;
  border-color: #e9edf3;
}

::v-deep .product-edit-dialog .el-select .el-input.is-disabled .el-input__inner {
  color: #606266;
}

::v-deep .session-table th {
  background: #f5f7fa;
  color: #606266;
}
</style>
